module.exports = __webpack_public_path__ + "static/media/logo.b80d7e1d.png";